import { useEffect, useState } from 'react';
import api from '../api/api';

const KEY = 'prokatprost_ozon_payment';
const CLEARED = 'prokatprost:ozon-payment-cleared';
export function clearOzonPayment(paymentRefs) {
  let saved;
  try { saved = JSON.parse(localStorage.getItem(KEY)); } catch { return; }
  if (!saved?.ref || !paymentRefs?.includes(saved.ref)) return;
  localStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent(CLEARED));
}

export function openOzonPayment(data) {
  const url = new URL(data.confirmation_url);
  if (url.protocol !== 'https:' || !(url.hostname === 'ozon.ru' || url.hostname.endsWith('.ozon.ru')) || url.username || url.password) {
    throw new Error('Неверная ссылка Ozon');
  }
  localStorage.setItem(KEY, JSON.stringify({ ref: data.payment_ref, started: Date.now(), extensionDealId: data.extension_deal_id }));
  window.location.assign(url.href);
}

export function useOzonPaymentStatus() {
  const [status, setStatus] = useState('');
  useEffect(() => {
    let active = true, busy = false;
    const cleared = () => { if (active) setStatus(''); };
    const check = async () => {
      if (busy || document.visibilityState === 'hidden') return;
      let saved, stored;
      try { stored = localStorage.getItem(KEY); saved = JSON.parse(stored); } catch { return; }
      if (!saved?.ref || Date.now() - saved.started > 60 * 60 * 1000) return;
      busy = true;
      try {
        const { data } = await api.get(`/payments/ozon/status/${encodeURIComponent(saved.ref)}`, { skipLoading: true });
        // A cancellation or another checkout can supersede an in-flight reply.
        if (!active || localStorage.getItem(KEY) !== stored) return;
        setStatus(data.status === 'order_canceled' ? '' : data.status);
        if (saved.extensionDealId && ['paid', 'canceled', 'order_canceled', 'test_paid', 'refunded', 'test_refunded'].includes(data.status)) {
          localStorage.removeItem(`prokatprost_extension_${saved.extensionDealId}`);
        }
        if (['paid', 'paid_after_cancel', 'test_paid', 'canceled', 'order_canceled', 'not_found', 'refunded', 'partially_refunded', 'test_refunded'].includes(data.status)) localStorage.removeItem(KEY);
      } catch (error) {
        if (active && localStorage.getItem(KEY) === stored) setStatus(error.response?.status === 409 ? 'review' : 'unavailable');
      } finally { busy = false; }
    };
    check();
    const timer = setInterval(check, 15000);
    window.addEventListener('focus', check);
    window.addEventListener(CLEARED, cleared);
    document.addEventListener('visibilitychange', check);
    return () => { active = false; clearInterval(timer); window.removeEventListener('focus', check); window.removeEventListener(CLEARED, cleared); document.removeEventListener('visibilitychange', check); };
  }, []);
  return status;
}

export const ozonStatusText = {
  paid_after_cancel: 'Заявка отменена, но оплата поступила. Сумма к возврату указана в истории заказа. Обратитесь в поддержку для возврата.',
  refunded: 'Возврат оплаты подтверждён Ozon. Обновите список заказов в личном кабинете.',
  partially_refunded: 'Частичный возврат подтверждён Ozon. Суммы доступны в личном кабинете.',
  test_refunded: 'Тестовый возврат подтверждён. Реальные деньги не перемещались.',
  not_found: 'Ozon не находит прежний платёж. Откройте оплату заказа заново. Если деньги списались, напишите в чат и не создавайте новый платёж.',
  paid: 'Оплата подтверждена.',
  test_paid: 'Тестовая оплата прошла. Реальные деньги не списаны, заказ не выдан и не отмечен оплаченным.',
  canceled: 'Платёж отменён или срок оплаты истёк.',
  pending: 'Ожидаем подтверждение оплаты от Ozon.',
  unavailable: 'Пока не удалось проверить оплату. Не оплачивайте повторно; проверка повторится.',
  review: 'Платёж требует проверки сотрудником. Напишите в чат, повторно не оплачивайте.',
};
